/** Корпоративный тариф: оплата по договору, без retail в ЛК. */
export const B2B_PLAN_SLUG = 'b2b'

/**
 * @param {object|null|undefined} source — wallet, profile или auth.user
 */
export function isB2bBillingUser(source) {
  if (!source || typeof source !== 'object') return false
  if (source.billing_b2b_wire) return true
  const plan = source.subscription_plan
  const slug = typeof plan === 'string' ? plan : plan?.slug
  return slug === B2B_PLAN_SLUG
}
